import {AxiosHeaders} from 'axios';
import {t} from '@lingui/core/macro';
import {createAsyncThunk} from '@reduxjs/toolkit';

import {ApiUrls} from 'shared/config/model/urls';
import SimpleResponse from 'shared/api/model/SimpleResponse';
import createHttpRequest from 'shared/api/http';

import {IAdditionalEmailConfirm} from './INotifyChannel';

export const confirmAdditionalEmail = createAsyncThunk<SimpleResponse, IAdditionalEmailConfirm>(
    'auth/confirmAdditionalEmail',
    async({token}) => {
        const headers = new AxiosHeaders();
        headers.setContentType('application/json', true);

        const response = await createHttpRequest({
            method: 'POST',
            data: {},
            headers,
            path: ApiUrls.ADDITIONAL_EMAIL_CONFIRM_GET(token),
            errorMessage: t`Ошибка при подтверждении доп. Email`,
            isAnonymous: true,
        });

        return response.data;
    },
);
